var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.DefaultLayout,{attrs:{"salesMenu":true,"estimateMenu":true}},[_c(_setup.EstimateSearch),_c(_setup.EstimateSearchTable)],1),_c(_setup.EstimateDetailDialog)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }